<template>
  <div id="app">

    <router-view/>

    <transition name="fade">
      <div class="progressbar" v-if="progressbar" />
    </transition>

  </div>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    progressbar: false
  }),

  mounted() {
    this.$router.beforeEach((to, from, next) => {
      if (to.path !== from.path) {
        this.progressbar = true
      }
      next()
    })
    this.$router.afterEach(() => {
      this.progressbar = false
    })
  }
}
</script>

<style lang="scss">
.progressbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 2px;
  background: linear-gradient(
    45deg,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.1) 25%,
    rgba(0, 0, 0, 0.7) 50%,
    rgba(0, 0, 0, 0.99) 75%,
    rgba(0, 0, 0, 0)
  );
  transition: all 0.3s ease-in-out 0s;
  transform: translateX(100%);
  backface-visibility: hidden;
  animation: progressbar 1.3s cubic-bezier(0.2, 0.5, 0.4, 0.7) infinite;
  animation-delay: 0.1s;
  will-change: transform;
}
@keyframes progressbar {
  0% {
    transform:translateX(-100%)
  }
  50%{
    transform:translateX(0)
  }
  to{
    transform:translateX(100%)
  }
}
</style>
